module.exports = __webpack_public_path__ + "assets/img/Integrity_badge_Light_EN.c95f1502.png";